import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import axios, { AxiosResponse, AxiosError } from 'axios';
import * as constants from './FMImagesConstants';
import { IconType, IconData } from './FMImagesReducer';

export interface ReplaceIconsData {
    type: constants.REPLACE_ICONS_DATA;
    iconsType: IconType;
    iconsData: IconData[];
}

export type Action = ReplaceIconsData;

export const replaceIconsData = (
    iconsType: IconType,
    iconsData: IconData[],
): ReplaceIconsData => ({
        type: constants.REPLACE_ICONS_DATA,
        iconsType,
        iconsData,
    });

export const fetchGeopointIcons = (): ThunkAction<Promise<void>, {}, {}, AnyAction> =>
    async (dispatch): Promise<void> =>
        new Promise<void>(resolve => {
            axios.get('/api/Api.svc/getgeozonesicons')
                .then((response: AxiosResponse) => {
                    dispatch(replaceIconsData(
                        IconType.geoPoint,
                        response.data,
                    ));
                    resolve();
                })
                .catch((error: AxiosError) => {
                    alert(fmtools.translate('api_request_error'));
                    console.error(error.response ? error.response : error);
                    resolve();
                });
        });
